import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import moment from 'moment';
import { useContext } from 'react';
import { useSearchInput } from 'hooks/useSearchInput';
import { AppContext } from 'shared/AppContext';

const CommonEventFieldsFragment = gql`
  fragment commonEventFields on Event {
    id
    name
    fullDate
    start_date
    end_date
    off_sale_time
    admin_website_url
    image
    logo
    status
    isMultiDay
    listDates
    day
    date
    month
    year
    track {
      id
      name
    }
  }
`;

export const GET_TRACK_REGISTRATIONS = gql`
  query GetTrackRegistrations($input: GetAccountEventsInput!) {
    getEventsByAccount(input: $input) {
      count
      results {
        ...commonEventFields
        nextGateTime
        tickets {
          name
          price
          date
        }
        other_tickets {
          name
          price
        }
      }
    }
  }
  ${CommonEventFieldsFragment}
`;

export function useGetTrackRegistrations() {
  const { input: search } = useSearchInput();
  const {
    state: { accountId },
  } = useContext(AppContext);

  // Get year from URL params, default to current year
  const thisYear = Number(moment().format('YYYY'));
  const yearFilter = search.year ? Number(search.year) : thisYear;

  // Only include queryString from search params for GraphQL
  const queryString = search.queryString || '';

  // Get page number from URL (as string for this API)
  const page = search.page ? String(search.page) : '1';

  const result = useQuery(GET_TRACK_REGISTRATIONS, {
    variables: {
      input: {
        queryString,
        year: yearFilter,
        account_id: accountId,
        page,
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  return result;
}
